import request from '@/utils/request';

export function listBackstageUserInfo(data) {
  return request({
    url: '/merchant-backstage-user/listBackstageUserInfo',
    method: 'post',
    data,
  });
}
export function cancelBackstageUserInfo(params) {
  return request({
    url: '/merchant-backstage-user/cancelBackstageUserInfo',
    method: 'get',
    params,
  });
}
// 查询用户权限列表
export function listBackstageUserAuthority(params) {
  return request({
    url: '/merchant-backstage-user/listBackstageUserAuthority',
    method: 'get',
    params,
  });
}
// 新增或者修改成员信息
export function saveBackstageUserInfo(data) {
  return request({
    url: '/merchant-backstage-user/saveBackstageUserInfo',
    method: 'post',
    data,
  });
}
